const BusinessDropdownTypes = {
  ICON: 'icon',
  NAVIGATION: 'navigation',
};

export default BusinessDropdownTypes;
